require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wanna-play-linux-meetup-0.json") })
        }
      }, "path---wanna-play-linux-meetup-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wanna-play-linux-meetup-0!./.cache/json/wanna-play-linux-meetup-0.json
// module id = 498
// module chunks = 231608221292675